import { render } from "./UserPromotion.vue?vue&type=template&id=514898f8&scoped=true"
import script from "./UserPromotion.vue?vue&type=script&lang=js"
export * from "./UserPromotion.vue?vue&type=script&lang=js"

import "./UserPromotion.vue?vue&type=style&index=0&id=514898f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-514898f8"]])

export default __exports__